import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { message } from 'antd';

interface AuthGuardProps {
    children: React.ReactNode;
}

// 从环境变量读取鉴权开关（默认启用）
// Vite 环境变量必须以 VITE_ 开头才能在前端访问
const AUTH_ENABLED = import.meta.env.VITE_AUTH_ENABLED !== 'false';

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // 如果禁用了鉴权，直接跳过检查
        if (!AUTH_ENABLED) {
            return;
        }

        const token = localStorage.getItem('token');
        if (!token) {
            message.warning('请先登录', 1);
            // Save the current location they were trying to go to could be a nice enhancement, 
            // but typical login flows just go to dashboard or home. 
            // For now, strict redirect to login.
            navigate('/login', { replace: true, state: { from: location } });
        }
    }, [navigate, location]);

    // 如果禁用了鉴权，直接渲染子组件
    if (!AUTH_ENABLED) {
        return <>{children}</>;
    }

    // Ideally we might want to render a loading spinner or null while checking,
    // but since it's sync localStorage check, rendering children (which might flash) 
    // vs checking in render logic. 
    // To be safe and avoid flashing protected content, we can check conditional rendering.

    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }

    return <>{children}</>;
};

export default AuthGuard;
